export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(" ");
};

export const isPinValid = (pin: string[]) => {
  return pin.every((digit) => digit.match(/^[0-9]$/));
};
